import {
  Box,
  Card, CircularProgress, Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles({
  root: {
    flex: 1,
    display: 'flex',
    margin: '10px 10px 10px 0',
    padding: 8,
    justifyContent: 'space-between',
    minWidth: 345,
  },
});

function CircularProgressWithLabel({
  value, sx, size, ...props
}) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" size={size} sx={sx} value={value} {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          height: size,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: sx.color }}
        >
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

const Objective = ({ objective = { intitule: 'MARS 2022', ca: 10000000 } }) => {
  const classes = useStyles();
  return (
    <Card className={classes.root}>
      <Box sx={{ display: 'flex', mr: 1 }}>
        <CircularProgressWithLabel sx={{ color: '#00B894' }} variant="determinate" disableShrink thickness={4} value={80} size={70} />
        <CircularProgressWithLabel sx={{ color: '#E4C75C' }} variant="determinate" thickness={6} value={40} size={50} />
      </Box>
      <Box sx={{
        display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly',
      }}
      >
        <Typography sx={{
          color: '#343434',
          font: 'normal normal 600 12px Montserrat',
        }}
        >
          {`Du ${objective.startDate} au ${objective.endDate}`}
        </Typography>
        <Typography sx={{ mt: 1.5, mb: 1.5, font: 'normal normal 600 18px Montserrat' }}>
          {objective.intitule || objective.message || '-*-'}
        </Typography>
        <Typography sx={{ color: '#007BC6', font: 'normal normal 600 12px Montserrat' }}>
          {`${objective.products || objective.target} UNITÉS PAR MOIS`}
        </Typography>
      </Box>
    </Card>
  );
};

export default Objective;
